module.exports = {"131127100":"景州镇","131127101":"龙华镇","131127102":"广川镇","131127103":"王瞳镇","131127104":"洚河流镇","131127105":"安陵镇","131127106":"杜桥镇","131127107":"王谦寺镇","131127108":"北留智镇","131127109":"留智庙镇","131127200":"刘集乡","131127201":"连镇乡","131127202":"梁集乡","131127203":"温城乡","131127204":"后留名府乡","131127205":"青兰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131127.json
// module id = 224
// module chunks = 0